module.exports = __webpack_public_path__ + "static/media/choithramsLaysBrand.0bcd502d.jpg";